import { Grid } from '@mui/material';
import React from 'react'
import { useTranslation } from 'react-i18next';
import PiChart from '../../components/PiChart';
import TitleLink from '../../components/TitleLink';
import WhiskerChart from '../../components/WhiskerChart';

function Progress() {
  const {t} = useTranslation('global');

  const labels = ['0% - 25%', '25% - 50%', '50% - 75%', '75% - 100%'];
  const series = [44, 55, 13, 43];
  const mvcseries = [16, 56, 23, 83];

  const stsTitle = [20, 46, 20, 57];


  // 1 WhiskerChart
const w1 = {
  title: t('modumMax'),
  dataSet:[54, 66, 69, 75, 88]
};
const w2 = {
  title:t('stsCount'),
  dataSet:[12, 26, 49, 65, 88]
};
const w3 = {
  title:t('stsEnergy'),
  dataSet:[2, 26, 42, 75, 98]
};


  // 2 WhiskerChart
  const w4 = {
    title: t('stsMusculd'),
    dataSet:[54, 66, 69, 75, 88]
  };
  const w5 = {
    title:t('exerciseSessionEnergy'),
    dataSet:[12, 26, 49, 65, 88]
  };
  const w6 = {
    title:t('exerciseSessionMuscleActivity'),
    dataSet:[2, 26, 42, 75, 98]
  };


  return (
    <div>
      
      <div className='full-container'>
        <TitleLink
          boxTitle={t('progress')}
          enableButton={false}
          enableLink={false}
        /> 

        <div>
        
            <Grid container sx={{display:'flex', justifyContent:'center'}}>
              <PiChart 
                title={t(`progressDetails`)}
                series={series}
                labels={labels}
              />
              <PiChart 
                title={t('mvcDetails')}
                series={mvcseries}
                labels={labels}
              />
              <PiChart 
               title={t(`stsDetails`)}
               series={stsTitle}
               labels={labels}

              />
            </Grid>
         
        </div>
        
        <div>
        
          <Grid container sx={{display:'flex', justifyContent:'center'}}>
           
              <WhiskerChart
                w={w1}
              />
           
              <WhiskerChart 
                w={w2}
              />
          
              <WhiskerChart 
              w={w3}
              />
               </Grid>
            <Grid container sx={{display:'flex', justifyContent:'center'}}>
              <WhiskerChart
                w={w4}
              />
           
              <WhiskerChart 
                w={w5}
              />
           
              <WhiskerChart 
                w={w6}
              />
           
          </Grid>
        
        </div>
        
      </div>
    </div>
  )
}


export default Progress;